// extracted by mini-css-extract-plugin
module.exports = {"root":"SortAdornment_root__1v_4z","icon":"SortAdornment_icon__3IRWx","up":"SortAdornment_up__1YLy9","down":"SortAdornment_down__3KrvV","active":"SortAdornment_active__22JuV"};